import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import AppProvider from 'providers/AppProvider';
import { router } from 'routes';
import 'helpers/initFA';
import OwlApcProvider from 'owl/OwlApcProvider';

const container = document.getElementById('main');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AppProvider>
      <OwlApcProvider>
        <RouterProvider router={router} />
      </OwlApcProvider>
    </AppProvider>
  </React.StrictMode>
);
